// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-fixture-field__container {
    border: 1px solid var(--new-gray-background-color);
    padding: 16px 10px;
    border-radius: 4px;
    margin-top: 16px;
}

.tournament-fixture-field__field {
    display: flex;
    align-items: center;
}

.tournament-fixture-field__field .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-left: 6px;
}

.tournament-fixture-field__field .hubicon-stadium {
    color: var(--basic-gray-color);
    font-size: 20px;
}

.tournament-fixture-field__field .hubicon-edit {
    margin-left: auto;
    font-size: 18px;
    cursor: pointer;
}

.tournament-fixture-field__teams {
    margin-top: 16px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 4px;
    padding: 12px;
}

.tournament-fixture-field__teams-title {
    display: flex;
    align-items: center;
}

.tournament-fixture-field__teams-title .baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-left: 6px;
}

.tournament-fixture-field__teams-title .hubicon-shield {
    color: var(--basic-gray-color);
    font-size: 18px;
}

.tournament-fixture-field__teams .baloa-username {
    color: var(--primary-dark-color);
    margin-top: 12px;
}

.tournament-fixture-field__teams-container {
    display: flex;
    margin-top: 12px;
    gap: 8px;
    flex-wrap: wrap;
}

.tournament-fixture-field__teams-tag {
    border-radius: 25px;
    border: 1px solid var(--new-gray-background-color);
    width: fit-content;
    padding: 6px 8px;
    display: flex;
    align-items: center;
}

.tournament-fixture-field__teams-tag__date-info {
    text-align: center;
    padding: 0 12px;
    display: flex;
    align-items: center;
}

.tournament-fixture-field__teams-tag__date-info img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

.tournament-fixture-field__teams-tag__date-info .icon-ball {
    padding: 3px;
    font-size: 24px;
    color: var(--white-color);
    font-weight: var(--font-bold);
    border-radius: 50%;
}

.tournament-fixture-field__teams-tag__button {
    cursor: pointer;
}

.tournament-fixture-field__teams-tag__button .hubicon-clear_option{
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

.tournament-fixture-field__teams-tag__date-info .baloa-username {
    margin-top: 0;
    color: var(--primary-very-dark-color);
    text-transform: capitalize;
    margin-left: 4px;
}

.tournament-fixture-field__teams-tag__date-info .baloa-mini {
    color: var(--primary-dark-color);
}

.tournament-fixture-field__teams__button span.icon{
    grid-area: icon;
    margin-right: 4px;
}

.tournament-fixture-field__teams__button.rounded-button.small {
    padding: 6px 8px !important;
    height: fit-content;
    font-size: 14px;
}

.tournament-fixture-field__btn-options {
    padding: 8px;
    background-color: var(--white-color);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    box-shadow: var(--shadow);
    position: fixed;
    margin-top: 4px;
    display: none;
}

.tournament-fixture-field__btn-options.open {
    display: block;
}

.tournament-fixture-field__btn-options .baloa-names {
    color: var(--primary-very-dark-color);
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.tournament-fixture-field__btn-options .baloa-names:hover {
    background-color: var(--new-background-color);
}

.tournament-fixture-field__field-options .MuiPaper-root {
    padding: 8px;
    background-color: var(--white-color);
    border-radius: 8px;
    box-shadow: var(--shadow);
    margin-top: 4px;
}

.tournament-fixture-field__field-options .MuiList-padding {
    padding-top: 0;
    padding-bottom: 0;
}

.tournament-fixture-field__field-options .MuiMenuItem-root {
    color: var(--primary-very-dark-color);
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-fixture-field/TournamentFixtureFieldComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".tournament-fixture-field__container {\n    border: 1px solid var(--new-gray-background-color);\n    padding: 16px 10px;\n    border-radius: 4px;\n    margin-top: 16px;\n}\n\n.tournament-fixture-field__field {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-fixture-field__field .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-left: 6px;\n}\n\n.tournament-fixture-field__field .hubicon-stadium {\n    color: var(--basic-gray-color);\n    font-size: 20px;\n}\n\n.tournament-fixture-field__field .hubicon-edit {\n    margin-left: auto;\n    font-size: 18px;\n    cursor: pointer;\n}\n\n.tournament-fixture-field__teams {\n    margin-top: 16px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.tournament-fixture-field__teams-title {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-fixture-field__teams-title .baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-left: 6px;\n}\n\n.tournament-fixture-field__teams-title .hubicon-shield {\n    color: var(--basic-gray-color);\n    font-size: 18px;\n}\n\n.tournament-fixture-field__teams .baloa-username {\n    color: var(--primary-dark-color);\n    margin-top: 12px;\n}\n\n.tournament-fixture-field__teams-container {\n    display: flex;\n    margin-top: 12px;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.tournament-fixture-field__teams-tag {\n    border-radius: 25px;\n    border: 1px solid var(--new-gray-background-color);\n    width: fit-content;\n    padding: 6px 8px;\n    display: flex;\n    align-items: center;\n}\n\n.tournament-fixture-field__teams-tag__date-info {\n    text-align: center;\n    padding: 0 12px;\n    display: flex;\n    align-items: center;\n}\n\n.tournament-fixture-field__teams-tag__date-info img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n}\n\n.tournament-fixture-field__teams-tag__date-info .icon-ball {\n    padding: 3px;\n    font-size: 24px;\n    color: var(--white-color);\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n}\n\n.tournament-fixture-field__teams-tag__button {\n    cursor: pointer;\n}\n\n.tournament-fixture-field__teams-tag__button .hubicon-clear_option{\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-fixture-field__teams-tag__date-info .baloa-username {\n    margin-top: 0;\n    color: var(--primary-very-dark-color);\n    text-transform: capitalize;\n    margin-left: 4px;\n}\n\n.tournament-fixture-field__teams-tag__date-info .baloa-mini {\n    color: var(--primary-dark-color);\n}\n\n.tournament-fixture-field__teams__button span.icon{\n    grid-area: icon;\n    margin-right: 4px;\n}\n\n.tournament-fixture-field__teams__button.rounded-button.small {\n    padding: 6px 8px !important;\n    height: fit-content;\n    font-size: 14px;\n}\n\n.tournament-fixture-field__btn-options {\n    padding: 8px;\n    background-color: var(--white-color);\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    box-shadow: var(--shadow);\n    position: fixed;\n    margin-top: 4px;\n    display: none;\n}\n\n.tournament-fixture-field__btn-options.open {\n    display: block;\n}\n\n.tournament-fixture-field__btn-options .baloa-names {\n    color: var(--primary-very-dark-color);\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 4px;\n    white-space: nowrap;\n}\n\n.tournament-fixture-field__btn-options .baloa-names:hover {\n    background-color: var(--new-background-color);\n}\n\n.tournament-fixture-field__field-options .MuiPaper-root {\n    padding: 8px;\n    background-color: var(--white-color);\n    border-radius: 8px;\n    box-shadow: var(--shadow);\n    margin-top: 4px;\n}\n\n.tournament-fixture-field__field-options .MuiList-padding {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n.tournament-fixture-field__field-options .MuiMenuItem-root {\n    color: var(--primary-very-dark-color);\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 4px;\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
